import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import './notificationTemplates.css';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const NewNotificationTemplate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    key: '',
    type: '',
    message: ''
  });
  const [error, setError] = useState('');

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.key || !form.type || !form.message) {
      return setError('Tous les champs sont obligatoires.');
    }

    try {
      await axios.post(`${API_BASE}/api/admin/notification-templates`, form);
      navigate('/admin/notification-templates');
    } catch (err) {
      console.error(err);
      setError("Erreur lors de l'ajout du modèle.");
    }
  };

  return (
    <DashboardLayout>
      <Box className="notification-templates-container">
        <Typography className="notification-templates-title">Nouveau modèle de notification</Typography>

        <Paper className="template-card">
          {error && <Typography color="error">{error}</Typography>}

          <div className="template-label">Clé (unique)</div>
          <TextField
            className="template-input"
            value={form.key}
            onChange={e => handleChange('key', e.target.value)}
            placeholder="ex: mission_nouvelle"
          />

          <div className="template-label">Type</div>
          <TextField
            className="template-input"
            value={form.type}
            onChange={e => handleChange('type', e.target.value)}
            placeholder="ex: mission"
          />

          <div className="template-label">Message</div>
          <TextField
            className="template-textarea"
            value={form.message}
            onChange={e => handleChange('message', e.target.value)}
            multiline
            placeholder="ex: 📢 Nouvelle mission : {{nomMission}}"
          />

          <Box className="template-actions">
            <Button className="save-btn" onClick={handleSubmit}>Ajouter</Button>
            <Button className="cancel-btn" onClick={() => navigate('/admin/notification-templates')}>Annuler</Button>
          </Box>
        </Paper>
      </Box>
    </DashboardLayout>
  );
};

export default NewNotificationTemplate;
